import { PeriodTypeId } from "../../../helpers/helpers";

const initialState = {
  loading: false,
  loanAmount: 1000,
  refundAmount: 0,
  overpaymentAmount: 0,
  term: 7,
  periodTypeId: PeriodTypeId.days, // дни,
  paymentAmount: 0,
};

export const loanReducer = (state = initialState, action = null) => {
  switch (action.type) {
    case "CHANGE_LOADING":
      return { ...state, loading: action.payload };
    case "CHANGE_LOAN_AMOUNT":
      return { ...state, loanAmount: action.payload };
    case "CHANGE_REFUND_AMOUNT":
      return { ...state, refundAmount: action.payload };
    case "CHANGE_OVERPAYMENT_AMOUNT":
      return { ...state, overpaymentAmount: action.payload };
    case "CHANGE_TERM_AMOUNT":
      return { ...state, term: action.payload };
    case "CHANGE_PERIOD_TYPE":
      return { ...state, periodTypeId: action.payload };
    case "CHANGE_PAYMENT_AMOUNT":
      return { ...state, paymentAmount: action.payload };
    default:
      return state;
  }
};
